import React from "react";
import {
  Main,
  Timeline,
  Expertise,
  Project,
  Contact,
  Education,
  Footer,
  Skills,
  About
} from "../components";
import FadeIn from "../components/FadeIn";

interface DashboardPageProps {
  mode: string;
}

const DashboardPage: React.FC<DashboardPageProps> = ({ mode }) => {
  return (
    <div className={`main-container ${mode === "dark" ? "dark-mode" : "light-mode"}`}  >
      <FadeIn transitionDuration={700}>
        <Main />
        <About />
        <Expertise />
        <Skills />
        <Timeline />
        <Education />
        <Project />
        <Contact />
      </FadeIn>
      <Footer />
    </div>
  );
};

export default DashboardPage;